export const badgeTagStyle = { fontSize: '14px', padding: '2px 8px' };

export const getGenderLabel = (gender, t) => {
    if (!gender) return t('not_available');
    const raw = String(gender).trim();
    const v = raw.toLowerCase();

    const map = {
        male: 'male',
        female: 'female',
    };

    const key = map[v];
    return key ? t(key) : raw;
};
